import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import SliderListItem from '../../../../../../list-items/SliderListItem';
import { previewHistoryBatch } from '../../../../store/extensions';

const VisualizerShadowOpacityListItem = (props) => {
    const { dropShadowSettingsOpacity, updateVisualizerSettings, maxDropShadowOpacity } = props;
    
    const onShadowOpacityChange = (value) => {
        previewHistoryBatch.start();
        
        updateVisualizerSettings({ 
            dropShadowSettings: { opacity: value } 
        });
    };
    
    return (
        <SliderListItem
            title='Opacity'
            value={dropShadowSettingsOpacity}
            displayMultiplier={100 / maxDropShadowOpacity}
            min={0}
            max={100}
            step={1}
            onValueChange={onShadowOpacityChange}
        />
    );
};

const mapStateToProps = (state) => {
    const { opacity: dropShadowSettingsOpacity } = state.createPreview.present.videoSettings.visualizer.dropShadowSettings;
    const { maxDropShadowOpacity } = state.create.maxValues;

    return { 
        dropShadowSettingsOpacity,
        maxDropShadowOpacity
    };
}

const mapDispatchToProps = (dispatch) => {
    const updateVisualizerSettings = (properties) => dispatch(createActions.updateVisualizerSettings(properties));
    return { updateVisualizerSettings }
}

export default connect(mapStateToProps, mapDispatchToProps)(VisualizerShadowOpacityListItem);